export default {
  checkrole(role, key, action) {
    var can
    switch (role) {
      case 'CADASTRO_DE_AGENTE':
        if (key === 'EXCBIO' || key === 'EXPBIO' || key === 'AUDIT' || key === 'FRAUD' || key === 'STATUS' || key === 'ERROS') {
          can = false
        } else can = !((key === 'MANAGE' && action === 'DELETE') || (key === 'MANAGE' && action === 'FRAUD' || key === 'PSBIO'))
        break
      case 'ANALISE_E_EXCLUSAO_DE_BIOMETRIAS':
        can = !(key === 'PSBIO' || key === 'EXPBIO' || key === 'AUDIT' || key === 'FRAUD' || key === 'STATUS' || key === 'ERROS')
        break
      case 'ADMIN':
        can = true
        break
      case 'SUPERVISOR':
        can = !(key === 'EXPBIO' || key === 'PSBIO')
        break
      case 'SUPORTE PSS/PSBIO':
        if (key === 'EXPBIO') {
          can = false
        } else if (key === 'AUDIT' && action === 'NIST') {
          can = false
        } else if (key === 'FRAUD' && action === 'SAVE') {
          can = false
        } else if (key === 'PSBIO') {
          can = true
        } else {
          can = true
        }
        break
      case 'SUPORTE':
        if (key === 'PSBIO' || key === 'EXCBIO' || key === 'EXPBIO' || key === 'STATUS' || key === 'ERROS' || key === 'AGENTSUPT') {
          can = false
        } else if (key === 'USERS' && action === 'SAVE') {
          can = false
        } else if (key === 'AUDIT' && action === 'NIST') {
          can = false
        } else if (key === 'MANAGE' && action === 'FRAUD') {
          can = false
        } else can = !(key === 'FRAUD' && action === 'SAVE')
        break
      case 'PADRAO':
        can = false
        break
    }

    return can
  }
}



// WEBPACK FOOTER //
// ./src/roles/index.js